import React from 'react';
import { useDesign } from '../../contexts/DesignContext';
import { useLoading } from '../../contexts/LoadingContext';

const FullScreenLoadingOverlay = ({ forceVisible = false, label = 'Loading…' }) => {
  const { loading: designLoading, designConfig } = useDesign();
  const { isLoading: globalLoading, bootstrapped } = useLoading();

  const visible = forceVisible || (!bootstrapped && (designLoading || globalLoading));

  if (!visible) return null;

  const spinnerColor = designConfig?.primary_color || '#4F46E5';

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{ zIndex: 2147483647 }}
      className="fixed inset-0 flex items-center justify-center bg-white backdrop-blur-sm"
    >
      <div className="flex flex-col items-center gap-3 rounded-2xl bg-white/90 px-6 py-5 shadow-xl ring-1 ring-black/5">
        <div
          className="h-10 w-10 animate-spin rounded-full border-[3px] border-gray-200"
          style={{ borderTopColor: spinnerColor }}
        />
        <div className="text-sm font-medium text-gray-700">{label}</div>
      </div>
    </div>
  );
};

export default FullScreenLoadingOverlay;
